<template lang="pug">
.onboard-modal
  b-modal(id="modal-scoped", @ok="onTakeoverOk", @cancel="onTakeoverCancel")
    template(#modal-header)
     
      h5 Annotationen vom Dokument übernehmen

    template(#default)
      // Mit KKS übernehmen und bestehende löschen
      div.mb-2 Zuordnung Übernahme-Optionen
      b-select(v-model="kks_take_overops", :options="[{text: 'Keine Zuordnung übernehmen', value: 'none'}, {text: 'Zuordnung ohne KKS übernehmen', value: 'without_kks'}, {text: 'Mit KKS übernehmen', value: 'with_kks'}]").form-control
      .mt-1
        b-select(v-model="keep_splits_overops", :options="[{text: 'Aktuelle Annotationen beibehalten und zusammenführen.', value: 'keep'}, {text: 'Aktuelle Annotationen überschreiben', value: 'delete'}]").form-control
      
      // Übernahme von Sachmerkmalen
      div.mb-2.mt-4 Sachmerkmale Übernahme-Optionen
      b-select(v-model="sachmerkmale_take_overops", :options="[{text: 'Keine Sachmerkmale übernehmen', value: 'without_sachmerkmale'}, {text: 'Mit Sachmerkmale übernehmen', value: 'with_sachmerkmale'}]").form-control
      .mt-1
        b-select(v-model="keep_sachmerkmale_overops", :options="[{text: 'Aktuelle Sachmerkmale beibehalten und zusammenführen.', value: 'keep'}, {text: 'Aktuelle Sachmerkmale überschreiben', value: 'delete'}]").form-control
      
      // Übernahme von Kommentaren
      div.mb-2.mt-4
        b-form-checkbox(v-model="takeover_comment") Kommentar übernehmen
      div.mb-2
        b-form-checkbox(v-model="takeover_comment_internal") Internen Kommentar übernehmen
      
    template(#modal-footer="{ ok, cancel }")
     
    
      b-button(size="sm", variant="secondary", @click="cancel()")
        | Abbrechen
      b-button(size="sm", variant="primary", @click="ok()")
        | Übernehmen
    

  b-modal(id="onboardmodal", :title="title", size="xl", ok-variant="primary", :hide-header="true" ref="onboardmodal", ok-title="Speichern",  @hide="checkCancel" cancel-title="Schließen" @ok="saveDocument").modal-fullscreen2
    
    template(v-if="document")
      
      b-row()       
        b-col(cols="6" v-if="document")
          div.d-flex.justify-content-between.align-items-center.mb-1
            h5.text-break {{ document.filename }}
            template(v-if="view_left=='main'")
              b-btn(@click="view_left='docsense'", size="sm", v-if="true") Sachmerkmale
                // Number in color red
                span.badge.badge-danger.ml-1 {{ document.extracted_information.length }}
            template(v-else)
              b-btn(@click="view_left='main'", size="sm") Zuordnungen

            
          .small.text-muted.text-break {{document.filepath}}
          div(v-if="view_left=='main'") 
            .div.mt-3(style="height: 300px; overflow-y: scroll;")
            
              KSSDCCAssign(@setpage="(x) => {jumpPage(x)}", :kss="document.selected_kss", :dcc="document.selected_dcc", :document="document", :kks_options="detail_list&&detail_list.entries ? detail_list.entries.map(x => x.kks) : []", :dcc_options="detail_list.all_classes", :dcc_labels="detail_list.relations && detail_list.relations.dcc_labels ? detail_list.relations.dcc_labels : {}", :export="true")
            
            .mt-3
              b-input-group(size="sm" class="bg-secondary").w-100.d-flex.justify-content-between.p-2  
                label.mr-3 Datumsangabe
                span()
                  input(type="text", v-model="document.best_date.text", size="sm", style="width: 120px")
                span.d-flex.justify-content-between
                  b-btn(@click="take_date_for_splits('all')" size="sm") Alle Splits setzen
                  b-btn(@click="take_date_for_splits('empty')" size="sm").ml-2 Leere Splits setzen

            .mt-3
              b-input-group(size="sm").w-100.d-flex.justify-content-between
                label.mr-3 Kommentar
                b-form-textarea(v-model="document.reviewed_comment", rows="2", placeholder="Bearbeitungskommentar (in Delta-Liste sichtbar)", size="sm", style="width: 100%")
            
            .mt-3
              b-input-group(size="sm").w-100.d-flex.justify-content-between
                label.mr-3 Interner Kommentar
                b-form-textarea(v-model="document.reviewed_comment_internal", rows="2", placeholder="Interner Bearbeitungskommentar", size="sm", style="width: 100%")
              
            .mt-3
              b-input-group(size="sm").w-100.d-flex.justify-content-between
              
                b-form-checkbox(v-model="document.reviewed", size="sm")
                  span.mr-3 Als geprüft makieren
          div(v-if="view_left=='docsense'" style="height: 600px; overflow-y: scroll; overflow-x: hidden;").pr-3
            .d-flex.justify-content-between.align-items-center.mb-1
              h5 Sachmerkmale
             
            .mt-3
              div(v-for="(info, idx) in document.extracted_information" :key="'d' + idx")
                b-row(:key="'d' + idx")
                  b-col(cols="4")
                    el-select.sachmerkmale-key-select(
                      v-model="document.extracted_information[idx].key",
                      size="small",
                      filterable,
                      allow-create,
                      default-first-option,
                      placeholder="Schlüssel wählen oder eingeben",
                      :style="{ width: '100%' }"
                    )
                      el-option(v-for="optKey in sachmerkmaleKeyOptions", :key="optKey", :label="optKey", :value="optKey")
                  b-col(cols="6")
                        span(v-if="docsense_extraction[document.extracted_information[idx].key] == 'string' || docsense_extraction[document.extracted_information[idx].key] == 'integer' || docsense_extraction[document.extracted_information[idx].key] == 'float' || !docsense_extraction[document.extracted_information[idx].key] || docsense_extraction[document.extracted_information[idx].key] == 'boolean' || docsense_extraction[document.extracted_information[idx].key] == 'int' || docsense_extraction[document.extracted_information[idx].key] == 'float' || docsense_extraction[document.extracted_information[idx].key] == 'bool'")
                          input(type="text", v-model="document.extracted_information[idx].value", size="sm").form-control
                        span(v-if="docsense_extraction[document.extracted_information[idx].key] && docsense_extraction[document.extracted_information[idx].key].indexOf('dict') > -1")
                          
                          template(v-for="(value2, key2) in document.extracted_information[idx].value")
                           
                            input(type="text", v-model="document.extracted_information[idx].value[key2]", size="sm", :placeholder="key2").form-control
                  b-col(cols="2")
                      div.d-flex.justify-content-between
                        input(type="text", v-model="document.extracted_information[idx].page", size="sm", @click.prevent="jumpPage(parseInt(document.extracted_information[idx].page))").form-control.mr-3
                 
                        a(@click.prevent="delete_extracted_information(idx)", href="#").small.mt-2
                          i.fas.fa-trash-alt
                      
              .mt-3.mb-1.p-2.shadow-md.bg-light.rounded
                .small Neue Sachmerkmale hinzufügen
                b-row().mt-2
                  b-col(cols="4")
                    el-select.sachmerkmale-key-select(
                      v-model="extracted_information_new.key",
                      size="small",
                      filterable,
                      allow-create,
                      default-first-option,
                      placeholder="Schlüssel wählen oder eingeben",
                      @change="choose_type",
                      :style="{ width: '100%' }"
                    )
                      el-option(value="", label="-- Bitte wählen --")
                      el-option(v-for="optKey in sachmerkmaleKeyOptions", :key="optKey", :label="optKey", :value="optKey")
                  b-col(cols="6")
                     
                      // if docsense_extraction[key] is a str or int
                      span(v-if="docsense_extraction[extracted_information_new.key] == 'string' || docsense_extraction[extracted_information_new.key] == 'integer' || !docsense_extraction[extracted_information_new.key] || docsense_extraction[extracted_information_new.key] == 'boolean' || docsense_extraction[extracted_information_new.key] == 'int' || docsense_extraction[extracted_information_new.key] == 'float' || docsense_extraction[extracted_information_new.key] == 'bool'")


                        input(type="text", v-model="extracted_information_new.value", size="sm", placeholder="Wert").form-control
                      // if docsense_extraction[key] is a dict
                      span(v-if="docsense_extraction[extracted_information_new.key] && docsense_extraction[extracted_information_new.key].indexOf('dict') > -1")
                        template(v-for="(value, key) in extracted_information_new.value")
                          input(type="text", v-model="extracted_information_new.value[key]", size="sm", :placeholder="key").form-control
                       
                  b-col(cols="2")
                    div.d-flex.justify-content-between
                      input(type="text", v-model="extracted_information_new.page", size="sm", @click.prevent="jumpPage(parseInt(extracted_information_new.page))", placeholder="Seite").form-control.mr-3
                    
                      a(@click.prevent="add_extracted_information()", href="#").small.mt-2
                     
                        i.fas.fa-plus
        
        b-col(cols="6", style="border-left: 1px solid #e9ecef;")
            .d-flex.justify-content-between.align-items-center.mb-1

              b-button-group()

                b-btn(@click="view='sim'", size="sm", v-if="sim_documents && sim_documents.length > 0") Ähnliche Dokumente
                  // Number in color red
                  span.badge.badge-danger.ml-1 {{ sim_documents.length }}

              .d-flex.justify-content-end.align-items-center.mb-1
              
                b-button-group()
                  b-btn(@click="view='pdf'", size="sm") PDF
                  b-btn(@click="view='kks'", size="sm") KKS-Splits

                  b-dropdown(size="sm", variant="secondary", text="More" class="z-index-1000")
                    b-dropdown-item(@click="fetchPages(); view='text'", size="sm") Text
                    b-dropdown-item(@click="view='toc'", size="sm", v-if="document.metadata && document.metadata.toc && document.metadata.toc.length > 0") Inhalt
                    b-dropdown-item(@click="view='info'", size="sm") Info
                  b-btn(@click="$refs.onboardmodal.hide()" size="sm").ml-2
                    i.fa.fa-times

            template(v-if="view === 'pdf'")
              template(v-if="document") 
                // Always show PDF inline regardless of size
                template(v-if="build_src && document.filename.toLowerCase().indexOf('.jpg') == -1")
                  template(v-if="pdf_arraybuffer")
                    vue-pdf-app(style="height: 80vh;" :pdf="pdf_arraybuffer", :file-name="document.filename"  @pages-rendered="onRender" , theme="light", :config="{toolbar: {}, sidebar: false}")
                  template(v-else) 
                    .d-flex.justify-content-center
                      div PDF wird geladen...
                        .mt-2
                          b-progress(:value="document_progress", :animated="true", :max="100", :show-progress="true", :striped="true", height="1.1rem", variant="primary")
                // Case 2: Document is a JPG and build_src is available
                template(v-else-if="build_src && document.filename.toLowerCase().indexOf('.jpg') > -1")
                  img(:src="build_src", style="width: 100%;")
                // Case 3: Fallback if build_src is missing or other issues when view is 'pdf' and document exists
                template(v-else)
                  b-alert.show(variant="warning", dismissible, fade)
                    | PDF-Viewer nicht verfügbar oder Quelldatei für dieses Dokument nicht gefunden.
              template(v-else)
                .d-flex.justify-content-center
                  div Dokumenten-Details werden geladen...
            
            div(v-if="view=='kks'")

                div().d-flex.justify-content-between.align-items-center.mb-1
                  h3.mt-4 Mögliche KKS-Splits
                  div
                    b-button(size="sm" @click="split_by_kks()") KKS Splits übernehmen

                b-input(v-model="kks_spilt_filter", type="text", placeholder="KKS filtern / RegEx", size="sm", @keyup.enter="addAssignment()").form-control

                // one item per row
                div.mt-4.small
                  div(v-for="finding in sortedFindings", :key="finding._id").d-flex.align-items-center.mb-2.justify-content-between.w-50
                    // Always show the page number for each finding
                    div
                      | {{finding.page+1}}
                    div {{finding.kks}}

            .d-flex.justify-content-between.mt-1.align-items-center.mb-1(v-if="view=='sim'")

              // Show similar documents

              // 3 in a row
              b-container(fluid)
                b-row
                  b-col(cols="12" md="4" v-for="simd in sim_documents" :key="simd._id" class="mb-4")
                    b-card(:title="simd.filename" :img-src="base_url + '/projects/' + simd.project_id + '/documents/' + simd._id + '/thumbnail'" img-alt="Document Thumbnail" img-top tag="article")
                      
                      b-card-text
                        b-badge(variant="secondary").mr-2 {{ simd.page_count }} Seiten
                        b-badge(variant="danger", v-if="document.metadata && simd.page_count != document.metadata.page_count") Untersch. Seitenanzahl
                        b-badge(variant="secondary", v-if="simd.relations.extracted_information_count") {{ simd.relations.extracted_information_count }} Sachmerkmale
                        b-badge(variant="secondary") Projekt {{ simd.relations.project.name }}
                        b-badge(variant="secondary") Similarity {{ 100 - simd.relations.distance }}%
                        b-badge(variant="success" v-if="simd.reviewed") Geprüft
                        //b-badge(variant="secondary") {{ simd.simhash }}
                       
                      b-button-group.mt-2
                        b-button(:href="'/dashboard/' + simd.project_id + '?openDocument=' + simd._id" target="_blank" size="sm", variant="primary") Öffnen
                        b-button(@click="takeover_from_sim(simd.project_id, simd._id)" size="sm", variant="primary").ml-1 Übernehmen
            
            
            div(v-if="view=='docsense'")

              // Form with row of extracted items one row per item
              div(v-for="(value, key) in docsense_extraction")
             
                  b-row(v-if="key != 'maintenances'").mb-0
                    b-col(cols="12")
                      b-form-group(id="fieldset-horizontal"
                        label-cols-sm="4"
                        label-cols-lg="3"
                        content-cols-sm
                        content-cols-lg="7"
                        :label="key"
                        label-size="sm"
                        label-for="input-horizontal")
                        b-form-input(v-model="docsense_extraction[key]", size="sm")
                  
                  b-row(v-if="key == 'maintenances'")
                  
                    b-col(cols="12")
                     
                        b-form-group(v-for="maint in value")
                        
                          b-row
                            b-col(cols="6")
                              b-form-input(v-model="maint.task", size="sm")
                            b-col(cols="6")
                              b-form-input(v-model="maint.period", size="sm")

            .d-flex.justify-content-between.mt-1.align-items-center.mb-1(v-if="view=='text'")
            
              template(v-if="document.document_pages && document.document_pages.page_list")
               
                b-textarea(v-model="document.document_pages.page_list[page_p-1].text_pdf", style="height: 700px").w-100
                b-textarea(v-model="document.document_pages.page_list[page_p-1].text_ocr", style="height: 700px").w-100
                b-textarea(v-model="document.document_pages.page_list[page_p-1].best_date", style="height: 200px").w-100
 
            .d-flex.justify-content-between.mt-1.align-items-center.mb-1(v-if="view=='toc'")
              b-table-simple(
                responsive,
                style="max-height: 700px; overflow-y: auto;",
                small,
                v-if="document.metadata"
              )
                b-tr
                  b-th()
                    | Ebene
                  b-th()
                    | Titel
                  b-th()
                    | Seite 
                  b-th()
                    | Aktion
                b-tr(v-for="(item, index) in document.metadata.toc", :key="index").p-0
                  b-td.p-0
                    .clamp-1 {{ item[0] }}
                  b-td.p-0
                    .d-inline-block(:style="{'padding-left': item[0] * 20 + 'px', 'font-weight': item[0] == 1 ? 'bold' : 'normal'}")
                      .clamp-1 {{ item[1] }}
                  b-td.p-0
                    b-btn(variant="link", size="sm", @click="page_p = item[2]")
                      | {{ item[2] }}
                  b-td.p-0
                    template(v-if="item.length < 4")
                      b-btn(variant="link", size="sm", @click="split_document(item, index)")
                        | Split
                    template(v-else)
                      b-btn(variant="link", size="sm", @click="split_document(item, index)")
                        span Split {{ item[3] }}

            .mb-1(v-if="view=='info'")
              div(style="height: 500px; overflow-y: auto;")
                div.small {{ document._id }}
                
                h6.mt-4 Meta-Daten
                b-table-simple(responsive, hover, small).table
                  
                  b-tr(v-for="(value, key) in document.metadata")
                    template(v-if="key != 'image_meta_data' && key != 'toc'")
                    
                      b-td
                        b {{ $t("metadata." + key) }}
                      b-td(v-if="value == 'True' || value == 'False'")
                        | {{ value ? 'Ja' : 'Nein' }}
                      b-td(v-else-if="key.includes('date')")
                        | {{ value ? value.substring(0, 10) : ''}}
                      b-td(v-else-if="Array.isArray(value)")
                        | {{ value.join(', ') }}
                      b-td(v-else)
                        | {{ value }}
                
                h6.mt-4 Klassifizierung Dokument
                  | {{ document.predicted_class_document }}
                
                  h6.mt-4 Klassifizierung Dokument
                  | {{ document.predicted_classes_pages }}
                
                h6.mt-4 KKS
                  div {{ document.kks_findings }}

                h6.mt-4 Dates
                  | {{ document.best_date }}

                h6.mt-4 TOC {{  document.metadata.extracted_toc_page_start  }}
                  | {{ document.metadata.toc }}


    template(v-else)
      b-alert.show(variant="warning", dismissible, fade)
        | Loading ...
              

</template>

<script>
// @ is an alias to /src

import VuePdfApp from "vue-pdf-app";
// import this to use default icons for buttons
import "vue-pdf-app/dist/icons/main.css";
import KSSDCCAssign from '@/components/KSSDCCAssign'
import Vue from 'vue'

import { pathToFileURL } from 'url';
import { hostname } from "os";
export default {

  name: 'OnboardModal',
  props: {
    class_options: {
      type: Array,
      default: () => []
    },
    config: {
      type: Object,
      default: () => {}
    },
    detail_list: {
      type: Object,
      default: () => {return {entries: [], all_classes: []}}
    }
  },
 
  data() {
      return {
        
        extracted_information_new: {key: '', value: '', page: ''},
        kks_take_overops: 'without_kks',
        sachmerkmale_take_overops: 'without_sachmerkmale',
        kks_spilt_filter: '*',

        keep_splits_overops: 'keep',
        keep_sachmerkmale_overops: 'keep',
        takeover_comment: true,
        takeover_comment_internal: true,
        takeover_project_id: null,
        takeover_document_id: null,
        selectedResult: 0,
        loading: true,
        document_progress: 0,
        org_document: null,
        checklists: [],
        docsense_extraction: {},
        pdfApp: null,
        document: null,
        page_p: 1,
        title: "PDF Viewer",
        options: {'withCredentials': true},
        build_src: null,
        pageCount: 0,
        rangeEdit: null,
        pdf_arraybuffer: null,
        view: "pdf",
        view_left: "main",
        sim_documents: [],
        userChoseInlineViewer: false,
    }
  },

  computed: {
    sachmerkmaleKeyOptions() {
      return Object.keys(this.docsense_extraction || {});
    }
  },

  mounted: function() {

    
  },

  methods: {

    fetchPdfArrayBuffer() {
      if (!this.build_src || !this.document || this.document.filename.toLowerCase().indexOf('.jpg') > -1) {
        // Don't fetch if no source, or if it's a JPG
        if(!this.build_src && this.document && this.document.filename.toLowerCase().indexOf('.jpg') == -1) {
          console.warn("fetchPdfArrayBuffer called without build_src for a PDF document.");
        }
        return;
      }
      this.pdf_arraybuffer = null; // Reset before fetching
      this.document_progress = 0; // Reset progress

      this.axios.get(this.build_src, { responseType: 'arraybuffer', onDownloadProgress: progressEvent => {
        const total = parseFloat(progressEvent.total);
        const current = progressEvent.loaded;
        if (total && total > 0) {
          this.document_progress = Math.floor(current / total * 100);
        } else {
          this.document_progress = 0; // Avoid NaN if total is 0 or undefined
        }
      }}).then((response) => {
        this.pdf_arraybuffer = response.data;
      }).catch(error => {
        console.error("Error fetching PDF arraybuffer:", error);
        this.$bvToast.toast('Fehler beim Laden des PDF-Dokuments', {
          title: "Fehler",
          variant: 'danger',
          solid: true
        });
      });
    },

    openPdfInNewTab() {
      if (this.build_src) {
        window.open(this.build_src, '_blank');
      } else {
        this.$bvToast.toast('PDF-Quelldatei nicht gefunden.', {
          title: "Fehler",
          variant: 'danger',
          solid: true
        });
      }
    },

    displayInlinePdf() {
      this.userChoseInlineViewer = true;
      this.fetchPdfArrayBuffer();
    },

    split_by_kks() {
      // empty assignments

      

      this.document.assignments = [];

      // get assigments per page
      let per_page = [];

      this.sortedFindings.forEach((finding) => {
        if(!per_page[finding.page]) {
          per_page[finding.page] = [];
        }
        per_page[finding.page].push(finding);
      });
   
      // iterate over all pages and create assignments
      per_page.forEach((findings, page) => {
        let selected_class = [];
        if(this.document.predicted_class_document && this.document.predicted_class_document.prediction_list[page] && this.document.predicted_class_document.prediction_list[page].class_name_list) {
          selected_class = this.document.predicted_class_document.prediction_list[page].class_name_list;
        }
        
        this.document.assignments.push({start: page+1, end: null, selected_class: selected_class, selected_kks: findings.map(x => x.kks), export: true})
      });

      // fill out end by looking at next start or end of document
      this.document.assignments.forEach((asgn, i) => {
        if(asgn.end == null) {
          let next_asgn = this.document.assignments[i+1];
          if(next_asgn) {
            
            asgn.end = next_asgn.start - 1
          } else {
            asgn.end = this.document.metadata.page_count;
          }
        }
      });

    

    },

   

    delete_extracted_information(key) {
      Vue.delete(this.document.extracted_information, key);
    },

    add_extracted_information() {
      this.document.extracted_information.push(this.extracted_information_new);
      this.extracted_information_new = {key: '', value: '', page: ''};
    },

    choose_type() {
      if (!this.extracted_information_new.key || !this.docsense_extraction[this.extracted_information_new.key]) {
        this.extracted_information_new.value = '';
        return;
      }
      if(this.docsense_extraction[this.extracted_information_new.key].indexOf('dict') > -1) {
        // parase string, eg 'Dict(task: str, period: str)' to get task and period
        // this.extracted_information_new.value = {task: '', period: ''};
        
        let dict_str = this.docsense_extraction[this.extracted_information_new.key].replace('dict(', '').replace(')', '');
        
        let dict_keys = dict_str.split(',').map(x => x.trim().split(':').map(x => x.trim()));
        let dict = {};
        dict_keys.forEach((key) => {
          dict[key[0]] = '';
        });
       
        this.extracted_information_new.value = dict;
      } else {
        this.extracted_information_new.value = '';
      }
    },



  
    take_date_for_splits(mode="all") {
      if(mode == "all")
        this.document.assignments.forEach((asgn) => {
        
          asgn.best_date = this.document.best_date;
          
        });
      else if(mode == "empty") {
        this.document.assignments.forEach((asgn) => {
        
          if(asgn.best_date == null || asgn.best_date.text == null || asgn.best_date.text == "") {
            asgn.best_date = this.document.best_date;
          }
        });
      }
    },

    merge_sachmerkmale(current_sachmerkmale, other_sachmerkmale) {
      // Ensure arrays exist
      if(!current_sachmerkmale) {
        current_sachmerkmale = [];
      }
      if(!other_sachmerkmale) {
        other_sachmerkmale = [];
      }

      // Create a set of existing keys for quick lookup
      let existing_keys = new Set();
      current_sachmerkmale.forEach((item) => {
        if(item && item.key) {
          existing_keys.add(item.key);
        }
      });

      // Merge sachmerkmale - only add items with new keys
      // Items with existing keys are kept from current_sachmerkmale
      other_sachmerkmale.forEach((other_item) => {
        if(!other_item || !other_item.key) return; // Skip items without key

        if(!existing_keys.has(other_item.key)) {
          // New key - add it
          current_sachmerkmale.push(this.$_.cloneDeep(other_item));
          existing_keys.add(other_item.key); // Track that we added it
        }
        // If key exists, we keep the existing one (don't add duplicate)
      });

      return current_sachmerkmale;
    },

    onTakeoverOk() {

      if(this.takeover_project_id == null || this.takeover_document_id == null) return;

      this.axios.get(this.base_url + '/projects/' + this.takeover_project_id + '/documents/' + this.takeover_document_id).then((response) => {
        let other_doc = response.data;

        // Handle assignments takeover - only if not 'none'
        if(this.kks_take_overops != 'none') {
          if(!this.document.selected_kks || this.kks_take_overops == 'without_kks') {
           
            other_doc.assignments.forEach((asgn) => {
             asgn.selected_kks = [];
           });

         }

          if(this.keep_splits_overops == 'delete') {
            this.document.assignments = [];
            this.document.assignments = other_doc.assignments;
          } else {
            this.document.assignments = this.document.assignments.concat(other_doc.assignments);
            // sort by page 
            this.document.assignments.sort((a, b) => a.start - b.start);
          }
        }
        // If kks_take_overops == 'none', don't take over any assignments

        // Handle sachmerkmale (extracted_information) takeover
        if(this.sachmerkmale_take_overops == 'with_sachmerkmale') {
          if(!this.document.extracted_information) {
            this.document.extracted_information = [];
          }
          
          if(!other_doc.extracted_information) {
            other_doc.extracted_information = [];
          }

          if(this.keep_sachmerkmale_overops == 'delete') {
            // Replace current sachmerkmale with other document's
            this.document.extracted_information = this.$_.cloneDeep(other_doc.extracted_information);
          } else {
            // Merge sachmerkmale (keep existing and add new ones)
            this.document.extracted_information = this.merge_sachmerkmale(
              this.document.extracted_information,
              other_doc.extracted_information
            );
          }
        }
        // If sachmerkmale_take_overops == 'without_sachmerkmale', do nothing (keep current)

        // Handle comment takeover
        if(this.takeover_comment && other_doc.reviewed_comment != null) {
          this.document.reviewed_comment = other_doc.reviewed_comment;
        }
        if(this.takeover_comment_internal && other_doc.reviewed_comment_internal != null) {
          this.document.reviewed_comment_internal = other_doc.reviewed_comment_internal;
        }

        this.$bvToast.toast('Dokument übernommen', {
          title: 'Erfolg',
          variant: 'primary',
          solid: true
        });

        this.takeover_project_id = null;
        this.takeover_document_id = null;

      });

      
    },

    onTakeoverCancel() {
      this.takeover_project_id = null;
      this.takeover_document_id = null;
    },



    takeover_from_sim(project_id, other_doc_id) {

      this.takeover_project_id = project_id;
      this.takeover_document_id = other_doc_id;

      this.$bvModal.show('modal-scoped');

     
    },

    split_document(item, index) {
      
      // find next chapter on same level
      let next_chapter = null
      for(let i = index+1; i < this.document.metadata.toc.length; i++) {
        if(this.document.metadata.toc[i][0] == item[0]) {
          next_chapter = this.document.metadata.toc[i]
          break
        }
      }

      if(!next_chapter) {
        for(let i = index+1; i < this.document.metadata.toc.length; i++) {
            next_chapter = this.document.metadata.toc[i]
            break
        }
      }

      if(item[3]) {
        this.document.assignments.push({start: item[2]-1, end: next_chapter[2] ? parseInt(next_chapter[2])-2 : null, selected_class: [item[3]], selected_kks: this.document.selected_kks, export: true})
      } else {
        this.document.assignments.push({start: item[2]-1, end: next_chapter[2] ? parseInt(next_chapter[2])-2 : null, selected_class: [], selected_kks: this.document.selected_kks, export: true})
      }
      
    },

    addAssignment() {
      this.document.assignments.push({start: 1, end: this.document.metadata.page_count, class: '', kks: [], best_date: {'text': ''}, export: true})
    },

    jumpPage(x) {
      this.view = 'pdf';
      this.pdfApp.page = x
    },

    saveDocument() {
      
      this.axios.put(this.base_url + '/projects/' + this.document.project_id + '/documents/' + this.document._id, this.document).then((res) => {
        this.rangeEdit = null;
        // toast
        // emit event
        this.$emit('saved', res.data);
        
        this.org_document = res.data;

        alert("Debug: Speichern erfolgreich")
        
        this.$bvToast.toast('Dokument gespeichert', {
          title: "Gespeichert",
          variant: 'primary',
          solid: true
        });

        this.rangeEdit = null;
        this.document = null;
        this.org_document = null;
        

      }).catch((error) => {
      // Error handling
        console.error("Error saving the document:", error);
        
        alert("Debug: FEHLER :\n" +  JSON.stringify(error))
          
        // Display error toast message
        this.$bvToast.toast('Fehler beim Speichern des Dokuments', {
          title: "Fehler",
          variant: 'danger',
          solid: true
        });
      
      });
  
    },

    saveRange(range) {
      let new_spans = [];

      // check validity
      if(range.start > range.end) {
        this.$bvToast.toast('Start muss kleiner als Ende sein', {
          title: 'Fehler',
          variant: 'danger',
          solid: true
        });
        return;
      }

      if(range.start < 1 || range.end > this.document.metadata.page_count) {
        this.$bvToast.toast('Start und Ende müssen innerhalb des Dokuments liegen', {
          title: 'Fehler',
          variant: 'danger',
          solid: true
        });
        return;
      }

      range.start = parseInt(range.start) - 1;
      range.end = parseInt(range.end) - 1;

      // Set end to max if end is higher than max
      if(range.end > this.document.metadata.page_count) {
        range.end = this.document.metadata.page_count;
      }
  
      this.document.split_spans.forEach((split, i) => {
        if(split.start >= range.start && split.end <= range.end) {
         
        } else if(split.start >= range.start && split.start <= range.end) {
          split.start = range.end+1;
          new_spans.push(split);
        } else if(split.end >= range.start && split.end <= range.end) {
          split.end = range.start-1;
          new_spans.push(split);
        } else {
          new_spans.push(split);
        }
        
      });
      
      new_spans.push(range);
      new_spans.sort((a, b) => a.start - b.start);
      

      this.document.split_spans = new_spans;
      
      this.rangeEdit = null;

      // update api
      /*this.axios.put(this.base_url + '/projects/' + this.document.project_id + '/documents/' + this.document._id, {split_spans: this.document.split_spans}).then((res) => {
        this.rangeEdit = null;
        // toast
        this.$bvToast.toast('Saved', {
          title: 'Success',
          variant: 'primary',
          solid: true
        });
      });*/

    },

    onRender(pdfApp) {
      console.log(pdfApp);
      if(pdfApp) {
        
        this.pdfApp = pdfApp;
        
        console.log(pdfApp.pdfViewer);
        
        this.pageCount = pdfApp.pdfViewer.pagesCount;
        pdfApp.pdfViewer.eventBus.on('pagechanging', ({ pageNumber }) => {
          this.page_p = pageNumber;
        });
      }
    },

    pageNumbersFrom(start) {
      let arr = [];
      for(let i = start+1; i <= this.pageCount; i++) {
        arr.push(i);
      }
      return arr;
    },

    checkCancel(ev) {

      
      
    
      const triggeredByPropChange = !ev.trigger;

    
        if (['esc', 'cancel'].includes(ev.trigger)) {
  
     
            if(this.checkDocumentChanges()) {
              
              if(ev) ev.preventDefault();
              
              this.$bvModal.msgBoxConfirm('Es wurden Änderungen vorgenommen, sollen diese verworden werden?', {
                title: 'Änderungen verwerfen?',
                size: 'sm',
                buttonSize: 'sm',
                okVariant: 'danger',
                okTitle: 'Verwerfen',
                cancelTitle: 'Abbrechen',
                hideHeaderClose: false,
                centered: true
              })
              .then((value) => {
              
                if(value) {
                
                  this.$refs.onboardmodal.hide();
                  this.document = null;
                  this.org_document = null;
                  this.rangeEdit = null;
                  
                } else {
                  if(ev) ev.preventDefault();
                  
                }
                
              })
              .catch(err => {
                // An error occurred
              
              })
            } else {
              
              this.document = null;
              this.org_document = null;
              this.rangeEdit = null;
              this.$refs.onboardmodal.hide();
                  
              
              
            } 
        // do the thing which changes the visibility
        }


    },

    checkDocumentChanges() {
   

      if(this.$_.isEqual(this.document, this.org_document)) {
        return false;
      } else {
        return true;
      }

    },


    checkLoading() {
      console.log(this.$refs.p_pdf.pdf);
    },

    fetchPages() {
      this.axios.get(this.base_url + '/projects/' + this.document.project_id + '/documents/' + this.document  ._id + '/pages').then((response) => {
        
        this.document.document_pages = response.data;
          
      });
    },

    get_similar_documents(doc) {
      this.sim_documents = [];
      if(doc.simhash  == null) return;
      if(doc._id == null) return;
      this.axios.get(this.base_url + '/similar_documents?simhash=' + doc.simhash + '&document_id=' + doc._id).then((response) => {
        this.sim_documents = response.data;
      });
    },

    open(doc, checklists = null) {




      this.pageCount = 0;
      this.page_p = 1;
      this.view = "pdf";
      this.rangeEdit = null;
      this.userChoseInlineViewer = true; // Always show PDF inline
      this.pdf_arraybuffer = null;
      this.document_progress = 0;
      this.build_src = null;

      this.org_document = doc;
      this.document = this.$_.cloneDeep(doc);
      this.sim_documents = [];

      this.checklists = checklists;
      if(this.checklists == null) {
        this.checklists = [];
      }
 
      if(this.checklists) {

        this.checklists.forEach((checklist) => {
          checklist.checklist_entries.forEach((entry) => {
              this.docsense_extraction[entry.item_to_be_checked] = entry.output_type;

              if(entry.output_type == 'dict') {
                if(entry.output_type_specifications) { 
                  let tspec = '(';
                  Object.entries(entry.output_type_specifications).forEach((value, key) => {
                    tspec += value[0] + ': str, ';
                  });
                  tspec = tspec.substring(0, tspec.length-2) + ')';
                  this.docsense_extraction[entry.item_to_be_checked] = 'dict' + tspec;
                }
              }
          });
        });
      }

      this.axios.get(this.base_url + '/projects/' + doc.project_id + '/documents/' + doc._id).then((response) => {
        this.org_document = response.data;
        
        if(this.org_document.best_date == null) {
          this.org_document.best_date = {'text': ''}
        }

        if(this.org_document.extracted_information == null) {
          this.org_document.extracted_information = [];
        }

        this.org_document.assignments.forEach((assignment, i) => {
          if(!assignment.best_date) {
            this.org_document.assignments[i].best_date = {'text': ''}
          }
        });

        this.document = this.$_.cloneDeep(this.org_document);

        if(this.document.extracted_information != null) {
          this.document.extracted_information.forEach((info) => {
            if(Object.keys(this.docsense_extraction).indexOf(info.key) == -1) {
              if(info.value && typeof info.value == 'object') {
                this.docsense_extraction[info.key] = 'dict(' + Object.keys(info.value).map(x => x + ': str').join(', ') + ')';
              } else {
                this.docsense_extraction[info.key] = "string";
              }
            }
          });
        }

        this.get_similar_documents(this.document);
        this.build_src = this.base_url + '/projects/' + this.document.project_id + '/documents/' + this.document._id + '/file'
        
        // Always load PDF content regardless of size
        if (this.document.filename.toLowerCase().indexOf('.jpg') === -1) {
          this.fetchPdfArrayBuffer();
        }
        
        this.fetchPages();
      });

      this.$refs.onboardmodal.show();

     
    },
    
    findPageInRangeM() {
        let ret_span = null;
        if(!this.document || !this.document.split_spans) return ret_span;

        this.document.split_spans.forEach((span) => {
          if(span.start <= (this.page_p-1) && span.end >= (this.page_p-1)) {
            ret_span = span
          }
        })
      
        return ret_span;
      },


    
  },

  computed: {

    sortedFindings() {

      let sorted = this.$_.sortBy(this.document.kks_findings, 'page');
      // filter by regex given in kks_split_filter
      if(this.kks_spilt_filter) {

        let re_filter = this.kks_spilt_filter.replace(/\*/g, '.*');
       
        sorted = sorted.filter((finding) => {
          
          
          // match kks_spilt_filter as regex on finding.kks
          let re = new RegExp(re_filter, 'i');
          console.log(finding.kss, re.test(finding.kks));
          return re.test(finding.kks);

        });
      }
      return sorted;
    },

    findPageInRange() {
      let ret_span = null;
      if(!this.document || !this.document.split_spans) return ret_span;

      this.document.split_spans.forEach((span) => {
        if(span.start <= (this.page_p-1) && span.end >= (this.page_p-1)) {
          ret_span = span
        }
      })
     
      return ret_span;
    },

    pageNumbers() {
      let ret = [];
      for(let i = 1; i <= this.pageCount; i++) {
        ret.push(i);
      }
      return ret;
    }
  },

  components: {
    VuePdfApp,
    KSSDCCAssign
  }
}

</script>

<style lang="scss" scoped>

.z-index-1000 {
  z-index: 100000;
}

.b-toast-primary {
  box-shadow: 0 0 0 5px hsl(207, 23%, 92%) !important;
  position: fixed;
  border-radius: 0px;
  width: 300px;
  right: 20px;
  top: 10px;
  .toast-header, .toast-body {
    background-color: #fff !important;
    font-size: 12px;
    color: #000;
  }
  background-color: #fff;
  padding: 10px;
}  

    ::v-deep #onboardmodal > .modal-dialog {
        margin: 0;
        overflow-y: scroll;
        max-width: 100%;
        max-height: 100%;
        width: 100%;
        max-height: 100%;
    }  
</style>

